import { Dispatch, SetStateAction } from 'react';
import { API } from 'apis';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { BankAccount, PaginationList, SellUtopiaManualBody, SellUtopiaManualResponse, User } from 'core/domain';

export interface UserOption {
    label: string;
    value: string;
    phoneNumber: string;
}

export const searchUsers = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<UserOption[]>>,
    keyword: string,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<User>>(
        `${API.users.getAll}/1/20${keyword ? `?keywords=${encodeURIComponent(keyword)}` : ''}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status) && response.value?.items) {
            setData(
                response.value.items.map((user: User) => ({
                    label: user.fullName?.trim() ? `${user.fullName} - ${user.phoneNumber}` : user.phoneNumber,
                    value: user.id,
                    phoneNumber: user.phoneNumber,
                })),
            );
        }
    });
};

// حساب های بانکی با کلیدواژه فیلتر می شوند و شماره موبایل کاربر هم یکی از فیلد های
// قابل جست و جو است، پس شماره موبایل کاربر انتخاب شده را به عنوان کلیدواژه می دهیم.
export interface BankAccountOption {
    label: string;
    value: string;
    /** متن قابل جست و جو: شبا، شماره کارت و نام بانک، با ارقام انگلیسی و حروف کوچک. */
    search: string;
}

export const getUserBankAccounts = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<BankAccountOption[]>>,
    phoneNumber: string,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<BankAccount>>(
        `${API.bankAccount.getAll}/1/50?keyWords=${encodeURIComponent(phoneNumber)}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status) && response.value?.items) {
            setData(
                response.value.items
                    .filter((account: BankAccount) => account.phoneNumber === phoneNumber)
                    .map((account: BankAccount) => {
                        const bankName = account.bankName || account.bank?.name || '';

                        return {
                            label: [account.iBan, bankName].filter(Boolean).join(' - '),
                            value: account.id,
                            search: [account.iBan, account.cardNumber, bankName]
                                .filter(Boolean)
                                .join(' ')
                                .toLowerCase(),
                        };
                    }),
            );
        }
    });
};

export const sellUtopiaManual = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<SellUtopiaManualResponse | undefined>>,
    body: SellUtopiaManualBody,
    onSuccess?: (result: SellUtopiaManualResponse) => void,
) => {
    setLoading(true);
    await postViaAuth<SellUtopiaManualResponse>(API.voucher.sellUtopiaManual, body).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status) && response.value) {
            setData(response.value);
            onSuccess && onSuccess(response.value);
        }
    });
};
